var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-file',{attrs:{"accept":".csv","placeholder":_vm.placeHolderText || _vm.$translate('assets_drop_file'),"drop-placeholder":_vm.dropPlaceHolderText || _vm.$translate('drop_file_here')},on:{"change":_vm.loadTextFromFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }